import axios from 'axios';
import i18n from '@/common/i18n/i18n.js';
import { setAxiosCsrfHeader } from '@/utils/requests.js';
const path = require('path');

const DEV_ENV = process.env.NODE_ENV === 'development';
const DEV_USERNAME = process.env.VUE_APP_API_ADMIN_USERNAME;
const DEV_PASSWORD = process.env.VUE_APP_API_ADMIN_PASSWORD;

class ApiClient {
  // API routes
  DASHBOARD_API_PATH = '/dashboard/';
  DATASET_API_PATH = '/dataset/';
  GEOSPATIAL_API_PATH = '/geospatial/';
  FILE_DOWNLOAD_API_APTH = '/resource/file-download/';
  FILE_UPLOAD_API_APTH = '/resource/file-upload/';
  FTP_API_APTH = '/resource/ftp/';
  HREF_API_APTH = '/resource/href/';
  INDEXER_API_PATH = '/indexer/';
  LOGIN_API_PATH = '/login/session/';
  ORGANISATION_API_PATH = '/organisation/';
  RESOURCE_API_PATH = '/resource/';
  USER_LOGIN_API_PATH = '/login/session/';
  USERGROUP_API_PATH = '/usergroup/';

  constructor() {
    this.client = axios.create();

    this.client.interceptors.request.use(
      (config) => {
        if (DEV_ENV) {
          const base64Credentials = btoa(`${DEV_USERNAME}:${DEV_PASSWORD}`);
          config.headers.Authorization = `Basic ${base64Credentials}`;
        }
        if (!DEV_ENV) {
          config.headers['X-CSRFToken'] = setAxiosCsrfHeader();
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  routeContainsDomain(route) {
    try {
      const url = new URL(route);
      return Boolean(url.hostname);
    } catch {
      return false;
    }
  }

  get(route, config = {}) {
    let url;
    if (this.routeContainsDomain(route)) {
      url = route;
    } else if (DEV_ENV) {
      // ONLY in DEV mode with relatives URLs to make the proxy work
      url = '/' + path.join(i18n.locale, route).replace(/\\/g, '/');
    } else {
      url = new URL(
        path.join(i18n.locale, route),
        window.location.origin
      );
    }
    return this.client.get(url, config);
  }

  post(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        window.location.origin
      );
    return this.client.post(url, data, config);
  }

  put(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        window.location.origin
      );
    return this.client.put(url, data, config);
  }

  delete(route, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        window.location.origin
      );
    return this.client.delete(url, config);
  }

  patch(route, data = {}, config = {}) {
    const url = this.routeContainsDomain(route)
      ? route
      : new URL(
        path.join(i18n.locale, route),
        window.location.origin
      );
    return this.client.patch(url, data, config);
  }
}

export default ApiClient;